export const supportedLanguages = ["en"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const rtlLanguages: SupportedLanguage[] = [];

export type TranslationFunction = (key: string, options?: Record<string, string | number>) => string;

export const isRTL = (language: SupportedLanguage): boolean => {
  return rtlLanguages.includes(language);
};
